class ReviewsOkendoAdapter {
  constructor(source_review) {
    this.source = "Okendo";
    this.source_review = source_review;

    this.id = this.reviewId();
    this.customer_name = this.customerName();
    this.title = this.title();
    this.content = this.content();
    this.customer_avatar = this.customerAvatar();
    this.customer_title = this.customerTitle();
    this.brand_logo = this.brandLogo();
    this.date = this.reviewDate();
    this.options = this.options();
    this.rating = this.rating();
    this.product_id = this.productId();
    this.product_total_reviews = this.productTotalReviews();
  }

  reviewId() {
    return this.source_review?.reviewId;
  }

  customerName() {
    return this.source_review?.reviewer?.displayName;
  }

  title() {
    return this.source_review?.title;
  }

  content() {
    return this.source_review?.body;
  }

  customerAvatar() {
    return this.source_review?.reviewer?.avatarUrl;
  }

  customerTitle() {
    return undefined;
  }

  brandLogo() {
    return undefined;
  }

  reviewDate() {
    return this.source_review?.dateCreated;
  }

  productId() {
    return this.source_review?.productId?.replace('shopify-', '');
  }

  options() {
    return {};
  }

  rating() {
    let rating = 5;

    if (this.source_review?.rating > 0) {
      rating = this.source_review?.rating;
    } else if (this.source_review?.ratingAndReviewValuesTotal > 0) {
      rating = this.source_review?.ratingAndReviewValuesTotal / this.source_review?.ratingAndReviewCount;
    }

    return rating;
  }

  productTotalReviews() {
    if (this.source_review?.ratingAndReviewCount === 0) return undefined;

    return this.source_review?.ratingAndReviewCount;
  }
}

if (typeof window !== 'undefined' && typeof window.convertflow == 'undefined') {
  window.ReviewsOkendoAdapter = ReviewsOkendoAdapter;
}
